import { render, staticRenderFns } from "./userSyjz.vue?vue&type=template&id=3183ada4&scoped=true&"
import script from "./userSyjz.vue?vue&type=script&lang=js&"
export * from "./userSyjz.vue?vue&type=script&lang=js&"
import style0 from "./userSyjz.vue?vue&type=style&index=0&id=3183ada4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3183ada4",
  null
  
)

export default component.exports